<template>
    <div>
        <div v-show="!inputActive">
            <p @click="openInput">
                {{ editableValue ? editableValue : "-" }}
            </p>
        </div>
        <div v-show="inputActive">
            <b-input-group
                size="sm"
                class="mb-3">
                <b-form-input v-model="inputText" ref="inputfield" @keyup.enter="commitInput"  @keyup.esc="cancelInput"></b-form-input>
                <b-input-group-append>
                <b-button variant="outline-success" @click="commitInput" ><i class="bi bi-check"></i></b-button>
                <b-button variant="outline-danger" @click="cancelInput"><i class="bi bi-x"></i></b-button>
                </b-input-group-append>
            </b-input-group>
        </div>
        <modal-error-component v-model="modalError"></modal-error-component>
    </div>
</template>
<script>
export default{
    props:{
        value: {
            type: String,
            required: false,
        },
        dataId: {
            type: Number,
            required: false,
        },
        dataPath: {
            type: String,
            required: false,
        }
    },
    data(){
        return{
            inputText: null,
            inputActive: false,
            modalError: {
                show: false,
                message: "unpopulated",
                error: "unpopulated",
                title: "unpopulated"
            },
        }
    },
    methods:{
        cancelInput() {
            this.inputActive = false;
            this.inputText = null;
        },
        openInput() {
            this.inputActive = true;
            this.inputText = this.value;
            Vue.nextTick( () => {
                this.$refs.inputfield.focus();
            })
        },
        commitInput() {
            //console.log("c-t-e component: commitInput")
            //console.log(this.dataPath)
            //console.log("id: " + this.dataId)
            //console.log("value: " + this.inputText)
            axios.put(this.dataPath, {
                id: this.dataId,
                value: this.inputText,
            })
            .then(response => {
                //console.log("c-t-e component: commitInput.then")
                //console.log("response: " + JSON.stringify(response))
                this.editableValue = this.inputText
                this.inputActive = false;
            }).
            catch(error => {
                console.log("c-t-e component: commitInput.catch")
                console.log("error: " + error)
                this.modalError = {
                    show: true,
                    message: "Speichern fehlgeschalgen.",
                    error: error,
                    title: "Fehlerr beim Speichern"
                };
            })
        }
    },
    computed: {
        editableValue: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>
<style>
</style>